import { renderIframeAndWaitForPostback, getThreeDsChallengeDisplaySize, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
const challenge_log = logTaggedMessage({
    module: '3ds',
    sub_module: 'worldpay_challenge',
});
export const performChallenge = async ({ data: actionData, provider, methodUrl }, log = challenge_log) => {
    const challengeDisplaySize = getThreeDsChallengeDisplaySize();
    const { jwt, orderCode, sessionId, machineCookie, correlationId, _PaymentOrderIdKey_, } = actionData;
    const dataToServer = {
        orderCode,
        sessionId,
        machineCookie,
        correlationId,
        _PaymentOrderIdKey_,
    };
    const success = () => ({
        challengeData: {
            provider,
            received: {},
            challengeDisplaySize,
            data: dataToServer,
        },
    });
    const fail = (error) => {
        return {
            challengeData: {
                challengeDisplaySize,
                provider,
                notReceived: { error },
                data: dataToServer,
            },
        };
    };
    const reqData = {
        JWT: jwt,
        MD: undefined,
    };
    const logData = {
        actionData,
        methodUrl,
        provider,
        reqData,
        dataToServer,
        machineCookie,
        correlationId,
    };
    log('3ds: before render Worldpay challenge', logData);
    const resultPromise = renderIframeAndWaitForPostback('visible', methodUrl ?? '', 'POST', reqData);
    try {
        await resultPromise;
        log('3ds: received Worldpay challenge success', logData);
        return success();
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'WORLDPAY',
            step: 'challenge',
            e,
        }));
        log('3ds: Worldpay Challenge failed', {
            ...logData,
            e,
            ret,
        });
        return ret;
    }
    finally {
        removeChallengeIframe();
    }
};
//# sourceMappingURL=worldpay-challenge.js.map